import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { clearAllExceptAccount } from "src/store/actions";
import BadDealApologiesModal from "./BadDealApologiesModal";

function mapStateToProps(store: ApplicationStore) {
    return {};
}

const mapDispatchToProps = (dispatch: any) => ({
    refreshDeal: () => {
        dispatch(clearAllExceptAccount());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(BadDealApologiesModal);
